/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  unref
} from 'vue';

import type {
  FilterOptionsList
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Commodity Types Filters
 */
export const commodityTypesFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOptionsList>(
      {url: `/filters/commodities/types`, method: 'GET', signal
    },
      );
    }




export const getCommodityTypesFiltersQueryKey = () => {
    return [
    'filters','commodities','types'
    ] as const;
    }


export const getCommodityTypesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof commodityTypesFilters>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodityTypesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCommodityTypesFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commodityTypesFilters>>> = ({ signal }) => commodityTypesFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commodityTypesFilters>>, TError, TData>
}

export type CommodityTypesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof commodityTypesFilters>>>
export type CommodityTypesFiltersQueryError = ErrorType<unknown>


/**
 * @summary Commodity Types Filters
 */

export function useCommodityTypesFilters<TData = Awaited<ReturnType<typeof commodityTypesFilters>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodityTypesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommodityTypesFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






